import React, { useEffect, useState } from 'react'
import { equals } from 'ramda'
import PropTypes from 'prop-types'

import { Dialog, Typography, makeStyles } from '@material-ui/core'

import InformationDialog from 'app/componentV4/Dialog/InformationDialog'
import FeatureHighlights from 'app/componentV4/FeatureHighlights/FeatureHighlights'

import Step1 from './Step1'
import Step2 from './Step2'
import useOnboard from './useOnboard'

const useStyles = makeStyles({
  input: {
    '&.MuiOutlinedInput-root': {
      height: '48px !important',
    },
  },
  groupLabel: { fontWeight: 700, color: '#000' },
  informationDialog: {
    '& .MuiDialog-paper': {
      width: '450px !important',
    },
  },
})

const Onboard = ({ isOnboard = false, onClose, onFetchProfile }) => {
  const classes = useStyles()
  const {
    state: { step, form },
    handleStep,
    handleForm,
    setupPlace,
    handleStep2,
    descriptionAI,
    checkGoogleCurated,
  } = useOnboard()

  const [isExisting, setIsExisting] = useState(false)

  useEffect(() => {
    setIsExisting(checkGoogleCurated?.data?.response?.existing)
  }, [checkGoogleCurated.data])

  useEffect(() => {
    if (step === 3) onFetchProfile()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [step])

  return (
    <>
      <Dialog
        open={isOnboard}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="md"
        PaperProps={{
          style: {
            borderRadius: 16,
            overflowY: 'unset',
          },
        }}
      >
        {step === 1 && (
          <Step1
            initial={form}
            onSubmit={(values) => {
              if (equals(values, form)) handleStep(2, false)
              else handleStep2(values)
            }}
            isLoading={descriptionAI.isPending || checkGoogleCurated.isPending}
          />
        )}
        {step === 2 && (
          <Step2
            initial={form}
            goTo={(step) => {
              handleStep(step)
            }}
            onChange={(values) => handleForm(values)}
            onSubmit={(value) => setupPlace.mutate(value)}
            isLoading={setupPlace.isPending}
          />
        )}
        {step === 3 && (
          <FeatureHighlights onClose={() => onClose()} isOnboard={true} />
        )}
      </Dialog>
      <InformationDialog
        id={'dialog-infomation-existing-name'}
        open={isExisting}
        title={
          'Place Name is is already registered on MessageSpring.'
          // <Typography className="text-16 font-500 text-primary">
          //   {'Place Name is is already registered on MessageSpring.'}
          // </Typography>
        }
        onClose={() => setIsExisting(false)}
        className={classes.informationDialog}
      >
        <div className="my-5">
          <Typography className="text-14 text-primary">
            {
              'If you’re affiliated with this business, please check with your team. If you believe this is a mistake, please contact us at support@messagespring.com.'
            }
          </Typography>
        </div>
      </InformationDialog>
    </>
  )
}

Onboard.propTypes = {
  onClose: PropTypes.func,
  isOnboard: PropTypes.bool,
  onFetchProfile: PropTypes.func,
}

export default Onboard
